// extracted by mini-css-extract-plugin
module.exports = {"section":"Partners_section___q6MD","client":"Partners_client__3c5Ql"};